import { fetchData } from 'services/fetchData';

import { authStore } from 'stores';

/**
 * Send a request to the API to create a new Auditort.
 * @param {Object} newAuditor details of the new Auditor.
 * @returns the newly created Auditor.
 */
export const createAuditor = async (newAuditor) => {
    const { jwtToken } = authStore.getState('passwordSession').value.sessionDetails;

    const httpOptions = {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${jwtToken}`,
            'Content-Type': 'application/json'
        },
        withCredentials: true,
        body: JSON.stringify(newAuditor)
    };

    const requestPath = `/auditor`;
    const { data } = await fetchData(requestPath, httpOptions);
    return data;
};
